(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const drawer = document.getElementById('ec-cart-drawer');
  if (!drawer) return;

  const body = drawer.querySelector('[data-ec-cart-drawer-body]');
  const footer = drawer.querySelector('[data-ec-cart-drawer-footer]');
  const subtotalEl = drawer.querySelector('[data-ec-cart-drawer-subtotal]');
  const subtotalLabelEl = drawer.querySelector('[data-ec-cart-drawer-subtotal-label]');
  const footerToggle = drawer.querySelector('[data-ec-cart-drawer-footer-toggle]');
  const shopKitsUrl = drawer.dataset.shopKitsUrl || '/';
  const sizeLabel = drawer.dataset.sizeLabel || 'Size';
  const emptyText = drawer.dataset.emptyText || 'Your cart is empty.';
  const continueLabel = drawer.dataset.continueLabel || 'Continue shopping';
  const loadingText = drawer.dataset.loadingText || 'Loading cart…';
  const moneyFormat = drawer.dataset.moneyFormat || '';
  const currency = drawer.dataset.currency || 'USD';
  const itemCountOneTemplate = drawer.dataset.itemCountOne || '@count item';
  const itemCountOtherTemplate = drawer.dataset.itemCountOther || '@count items';
  const hideSummaryLabel = drawer.dataset.hideSummary || 'Hide summary';
  const showSummaryLabel = drawer.dataset.showSummary || 'Show summary';
  const cartPageUrl = drawer.dataset.cartUrl || '/cart';
  const viewCartLabel = drawer.dataset.viewCart || 'View cart';

  const formatItemCount = (count) => {
    const template = count === 1 ? itemCountOneTemplate : itemCountOtherTemplate;
    return template.replace('@count', count);
  };

  footerToggle?.addEventListener('click', () => {
    if (!footer) return;
    footer.classList.toggle('is-collapsed');
    const expanded = !footer.classList.contains('is-collapsed');
    footerToggle.setAttribute('aria-expanded', String(expanded));
    footerToggle.setAttribute(
      'aria-label',
      expanded ? hideSummaryLabel : showSummaryLabel
    );
  });

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(cents / 100);
  };

  const getItemSize = (item) => {
    if (item.options_with_values) {
      for (const option of item.options_with_values) {
        if (option.name?.toLowerCase() === 'size') return option.value;
      }
    }
    if (item.properties) {
      for (const [key, value] of Object.entries(item.properties)) {
        if (key.toLowerCase() === 'size' && value) return value;
      }
    }
    return '';
  };

  const formatProductTitle = (rawTitle) => {
    if (!rawTitle) return '';

    const upper = rawTitle.toUpperCase();
    let sleeve = '';

    if (upper.includes(' SET LS') || upper.includes('L/S') || upper.includes(' LONG SLEEVE')) {
      sleeve = 'LS';
    } else if (upper.includes(' SET SS') || upper.includes('S/S') || upper.includes(' SHORT SLEEVE')) {
      sleeve = 'SS';
    }

    let name = rawTitle;
    const setIndex = upper.indexOf(' SET ');

    if (setIndex !== -1) {
      name = rawTitle.slice(0, setIndex);
    } else {
      const titleCaseSetIndex = rawTitle.toLowerCase().indexOf(' set ');
      if (titleCaseSetIndex !== -1) {
        name = rawTitle.slice(0, titleCaseSetIndex);
      }
    }

    name = name
      .replace(/\s*NO-GI COMPRESSION/gi, '')
      .replace(/\s*NO-GI/gi, '')
      .replace(/\s*COMPRESSION/gi, '')
      .trim();

    const titleCase = (value) =>
      value
        .toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    if (sleeve && name) {
      return `${titleCase(name)} Set ${sleeve}`;
    }

    if (name) {
      return titleCase(name);
    }

    return rawTitle;
  };

  const renderCart = (cart) => {
    if (!body || !footer || !subtotalEl) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <p class="ec-cart-drawer__empty-text">${emptyText}</p>
        <a class="ec-cart-drawer__empty-cta" href="${shopKitsUrl}">${continueLabel}</a>
      `;
      footer.hidden = true;
      return;
    }

    const itemsHtml = cart.items.map((item) => {
      const size = getItemSize(item);
      const sizeHtml = size ? `<p class="ec-cart-drawer__item-meta">${sizeLabel} · ${size}</p>` : '';
      const imageHtml = item.image
        ? `<img class="ec-cart-drawer__item-image" src="${item.image}" alt="" width="72" height="88" loading="lazy">`
        : `<div class="ec-cart-drawer__item-image"></div>`;

      return `
        <li class="ec-cart-drawer__item">
          <a href="${item.url}">${imageHtml}</a>
          <div>
            <p class="ec-cart-drawer__item-title"><a href="${item.url}">${formatProductTitle(item.product_title)}</a></p>
            ${sizeHtml}
            <p class="ec-cart-drawer__item-meta">${item.quantity} × ${formatMoney(item.final_price)}</p>
          </div>
          <p class="ec-cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
        </li>
      `;
    }).join('');

    body.innerHTML = `<ul class="ec-cart-drawer__items" role="list">${itemsHtml}</ul>`;
    subtotalEl.textContent = formatMoney(cart.total_price);
    if (subtotalLabelEl) {
      const subtotalBase = subtotalLabelEl.dataset.subtotalBase || 'Subtotal';
      subtotalLabelEl.textContent = `${subtotalBase} · ${formatItemCount(cart.item_count)}`;
    }
    footer.hidden = false;
    footer.classList.remove('is-collapsed');
    footerToggle?.setAttribute('aria-expanded', 'true');
    footerToggle?.setAttribute('aria-label', hideSummaryLabel);
  };

  const refreshCartDrawer = async () => {
    if (!body) return;
    body.innerHTML = `<p class="ec-cart-drawer__loading">${loadingText}</p>`;
    footer.hidden = true;

    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      body.innerHTML = `
        <p class="ec-cart-drawer__empty-text">${loadingText}</p>
        <a class="ec-cart-drawer__empty-cta" href="${cartPageUrl}">${viewCartLabel}</a>
      `;
    }
  };

  window.ecOpenCartDrawer = async () => {
    document.body.classList.add('ec-cart-drawer-open');
    drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    await refreshCartDrawer();
  };

  const closeDrawer = () => {
    drawer.close();
    document.body.classList.remove('ec-cart-drawer-open');
    document.documentElement.style.overflow = '';
  };

  drawer.querySelector('[data-ec-cart-drawer-close]')?.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });
  drawer.addEventListener('close', () => {
    document.body.classList.remove('ec-cart-drawer-open');
    document.documentElement.style.overflow = '';
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ec-open-cart-drawer]');
    if (!trigger) return;

    event.preventDefault();
    window.ecOpenCartDrawer();
  });

  window.ecRefreshCartDrawer = refreshCartDrawer;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ec-product-card"] && !Shopify.designMode) return;
  try {
    const updateHeaderCartCount = async () => {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');

      if (!cartLink) return;

      let badge = cartLink.querySelector('.site-header__cart-count');

      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('sup');
          badge.className = 'site-header__cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    } catch (error) {
      /* ignore */
    }
  };

  const findCardVariant = (form) => {
    const productJson = form.querySelector('[data-ec-card-product-json]');
    if (!productJson) return null;

    const productData = JSON.parse(productJson.textContent);
    const useSizeVariants = form.dataset.ecUseSizeVariants === 'true';

    if (!useSizeVariants) {
      return productData.variants.find((variant) => variant.available) || productData.variants[0];
    }

    const selectedOptions = [];
    form.querySelectorAll('[data-ec-card-option-input]:checked:not(:disabled)').forEach((input) => {
      const index = parseInt(input.dataset.optionIndex, 10);
      if (!Number.isNaN(index)) {
        selectedOptions[index] = input.value;
      }
    });

    return productData.variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );
  };

  const updateCardVariant = (form) => {
    const variant = findCardVariant(form);
    if (!variant) return;

    const variantInput = form.querySelector('[data-ec-card-variant-id]');
    const addButton = form.querySelector('[data-ec-card-add]');

    if (variantInput) variantInput.value = variant.id;

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.dataset.labelAdd
        : addButton.dataset.labelSoldOut;
      addButton.classList.remove('is-added');
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-ec-card-size]');
    if (!input) return;

    const form = input.closest('[data-ec-quick-add]');
    if (form) updateCardVariant(form);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ec-quick-add]');
    if (!form) return;

    event.preventDefault();

    const addButton = form.querySelector('[data-ec-card-add]');
    if (!addButton || addButton.disabled) return;

    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const sizeProperty = formData.get('properties[Size]');

    const item = {
      id: variantId,
      quantity: 1,
    };

    if (sizeProperty) {
      item.properties = { Size: sizeProperty };
    }

    addButton.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      addButton.textContent = addButton.dataset.labelAdded;
      addButton.classList.add('is-added');
      await updateHeaderCartCount();

      if (typeof window.ecOpenCartDrawer === 'function') {
        window.ecOpenCartDrawer();
      }

      window.setTimeout(() => {
        updateCardVariant(form);
      }, 1800);
    } catch (error) {
      addButton.disabled = false;
      addButton.textContent = addButton.dataset.labelAdd;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
